import { Injectable, inject } from '@angular/core';
import { SitemapEntry } from '@wdx/clmi/clmi-swagger-gen';
import { SitemapMatcherService as ISitemapMatcherService } from '@wdx/shared/infrastructure/state';
import { NavigationService } from './navigation.service';

/**
 * Implementation of SitemapMatcherService that uses NavigationService
 * to match routes to sitemap entries.
 */
@Injectable({ providedIn: 'root' })
export class WdxSitemapMatcherService implements ISitemapMatcherService {
    private navigationService = inject(NavigationService);

    matchPathToSitemap(
        path: string[],
        isAdminArea: boolean,
    ): SitemapEntry[] | undefined {
        const currentSiteMap = isAdminArea
            ? this.navigationService.getAdminSiteMap()
            : this.navigationService.getSiteMap();

        if (!currentSiteMap) {
            return undefined;
        }

        const pathParts = isAdminArea ? path.slice(2) : path.slice(1);
        const currentConfig: SitemapEntry[] = [];

        pathParts.forEach((part, index) => {
            if (index === 0) {
                currentConfig.push(
                    currentSiteMap.find((entry) => entry.code === part),
                );
            } else {
                const parentEntry = currentConfig[index - 1];
                currentConfig.push(
                    parentEntry?.children?.find((entry) => entry.code === part),
                );
            }
        });

        return currentConfig.length > 0 ? currentConfig : undefined;
    }

    getFullSitemap(isAdminArea: boolean): SitemapEntry[] | undefined {
        return isAdminArea
            ? this.navigationService.getAdminSiteMap()
            : this.navigationService.getSiteMap();
    }
}
